import Vue from "vue";
import { errorServeiceHandler, makeQueryStringDync } from "../helper";

const state = {
    rechargeAmount: undefined
    };
    const getters = {
        getRechargeAmount: state => {
        return state.rechargeAmount;
        }
    };
    const mutations = {
        setRechargeAmount: (state, data) => {
        state.rechargeAmount = data;
        }
    };

const actions = {
    actGetBanner: (context, payload) => {
        return new Promise((resolve, reject) => {
            if (!payload) {
                reject({ error: "payload not found" });
            }
            let data = makeQueryStringDync(payload);
            console.log('url', context.getters.baseUrl + "subscriber/v1/promo"+data)
            fetch(context.getters.baseUrl + "/subscriber/v1/promo"+data, {
                method: "GET"
            })
                .then(errorServeiceHandler)
                .then(response => {
                    return response.json();
                })
                .then(data => {
                    resolve(data);
                })
                .catch(error => {
                    reject(error);
                });
        });
    }
};

export default {
    actions, state, getters, mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/myIndigital.js